import { ApiEmployeeCompensationPerTypes } from "@/types/employees/employee-compensation.types.ts";
import { ApiCompensationTypeEnum } from "@/types/recruit/offer.types.ts";

export const getHireCompensationPrefill = (
  salaryType: ApiCompensationTypeEnum | null | undefined,
  salaryValue: string | null | undefined
) => {
  const value = salaryValue ? Number(salaryValue) : null;
  const isAnnual =
    salaryType === ApiCompensationTypeEnum.annual_gross ||
    salaryType === ApiCompensationTypeEnum.annual_net;
  const isMonthly =
    salaryType === ApiCompensationTypeEnum.monthly_gross ||
    salaryType === ApiCompensationTypeEnum.monthly_net;

  return {
    base_salary_gross:
      salaryType === ApiCompensationTypeEnum.annual_gross ||
      salaryType === ApiCompensationTypeEnum.monthly_gross
        ? value
        : null,
    base_salary_net:
      salaryType === ApiCompensationTypeEnum.annual_net ||
      salaryType === ApiCompensationTypeEnum.monthly_net
        ? value
        : null,
    per_type: isAnnual
      ? ApiEmployeeCompensationPerTypes.yearly
      : isMonthly
        ? ApiEmployeeCompensationPerTypes.monthly
        : undefined,
  };
};
